import {LatLng} from 'use-places-autocomplete';

export interface MetaData {
  zoomLevel?: string;
  distanceKm: number;
  locusDistanceKm: number;
}

export interface UserAddress {
  id: string;
  address1: string;
  address2: string;
  country: string;
  firstName: string;
  lastName: string;
  mobile: string;
  isDefault: boolean;
  company: string;
  isEligibleForExpress: boolean;
  subDistrict?: {
    id: string;
    nameTh: string;
    nameEn: string;
    __typename?: string;
  };
  province: {
    id: string;
    nameTh: string;
    nameEn: string;
    __typename?: string;
  };
  district: {
    id: string;
    nameTh: string;
    nameEn: string;
    __typename?: string;
  };
  zip: string;
  longitude?: number;
  latitude?: number;
  user_longitude?: number;
  user_latitude?: number;
  locus_longitude?: number;
  locus_latitude?: number;
  deliveryInstructions?: string;
  taxId?: string;
  branchId?: string;
  email?: string;
  metadata?: MetaData;
  __typename?: string;
}

export interface UserAddressV2
  extends Omit<UserAddress, 'id' | '__typename' | 'province' | 'district' | 'subDistrict'> {
  addressId: string;

  __v: number;
  _id: string;
  province: UserAddress['province'] & {
    _id: string;
    status: string;
    googleName: string;
  };
  district: UserAddress['district'] & {
    _id: string;
    provinceId: string;
    googleName: string;
  };
  subDistrict: UserAddress['subDistrict'] & {
    _id: string;
    districtId: string;
    googleName: string;
    code: string;
    zipCode: string;
    stores: {
      storeId: string;
      isExpress: boolean;
      isRegular: boolean;
    }[];
  };
}

export interface IDefaultUserAddressesResponse {
  getUserAddresses: Array<UserAddress>;
}

export type ShippingAddressType = {
  address: UserAddress;
  isLoading: boolean;
  onClick?: () => void;
};

export interface Address {
  id: string;
  address1: string;
  address2: string;
  province: string;
  provinceCode: string;
  city: string;
  company: string;
  country: string;
  countryCode: string;
  firstName: string;
  lastName: string;
  phone: string;
  zip: string;
  subdistrict?: string;
  latitude: number;
  longitude: number;
  metadata?: MetaData;
}

export interface TaxInfo {
  taxId: string;
  branchId: string;
  email?: string;
}

export interface BillingAddress extends Address, TaxInfo {}

export interface ShippingAddress extends Address {
  deliveryInstructions: string;
  isDefault?: boolean;
}

export interface AddressAreaLocale {
  id: string;
  nameTh: string;
  nameEn: string;
  __typename?: string;
}

export enum AddressTypeEnum {
  SHIPPING = 'SHIPPING'
}

export type TPinMapSelectedLocation = {
  coordinates?: LatLng;
  postalCode?: string;
  province?: string;
  district?: string;
  subdistrict?: string;
  subdistrictEn?: string;
  address?: string;
  zoomLevel?: number;
} | null;

export interface DistanceResult {
  distanceKm: number;
  latLng: {
    lat: number;
    lng: number;
  };
  addressString: string;
  isDistanceBeyondThreshold: boolean;
}

export interface MapAddressCoords {
  mapLatLng: LatLng;
  mapAddressString: string;
}

export type UserAddressWithOptionalCity = UserAddress & {city?: string};
